import React from 'react'
import '../loader.css'

export default function Loader() {
  return (
    <div  className='loader_div'>
        <span className='loader' ></span>
    </div>
  )
}
